// MEMBERS · Vitrina. Dos cosas, y las dos se apagan solas si el visitante ha pedido menos movimiento.
//
//   1. EL CONTADOR. Los puntos suben de 0 hasta el número real al abrir la pantalla. Es el único
//      gesto llamativo del panel, a propósito. El número REAL ya está escrito en el HTML por el
//      servidor: esto solo lo anima. Si el JavaScript no llega, el socio ve su cifra igual.
//   2. EL MODO DE EJEMPLO (?members_demo=0…4), que existe porque en Shopify Liquid NO PUEDE LEER
//      LOS PARÁMETROS DE LA URL: no hay `request.get`. Para un cliente de verdad no hace nada.
(function () {
  var quieto = false;
  try { quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { quieto = false; }

  var pon = function (sel, txt) {
    document.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
  };
  var mil = function (n) { try { return Number(n).toLocaleString(document.documentElement.lang === 'es' ? 'es-ES' : 'en-US'); } catch (e) { return String(n); } };

  // ── 1 · el contador ────────────────────────────────────────────────────────────────────────
  function contar(el, fin) {
    if (!el) return;
    if (quieto || !window.requestAnimationFrame) { el.textContent = mil(fin); return; }
    var t0 = null, dur = 1700;
    var paso = function (t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var suave = 1 - Math.pow(1 - p, 3);          // frena al llegar, como un contador de verdad
      el.textContent = mil(Math.round(fin * suave));
      if (p < 1) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  }

  var arranca = function () {
    var el = document.querySelector('[data-members-lifetime]');
    if (el) contar(el, parseInt(el.getAttribute('data-members-fin') || el.textContent || '0', 10) || 0);
  };

  // ── 2 · el modo de ejemplo ─────────────────────────────────────────────────────────────────
  var n = new URLSearchParams(location.search).get('members_demo');
  if (n === null) { arranca(); return; }

  // La MISMA escala que tiers.js del servidor y que el bloque Liquid de la sección.
  var NIVELES = {
    '0': { lifetime: 300,  saldo: 300,  etiqueta: '',        ventaja: 'points',   desde: 0,    hasta: 500,  siguiente: 'Level 1' },
    '1': { lifetime: 550,  saldo: 550,  etiqueta: 'Level 1', ventaja: '5% off',   desde: 500,  hasta: 1000, siguiente: 'Level 2' },
    '2': { lifetime: 1420, saldo: 1420, etiqueta: 'Level 2', ventaja: '10% off',  desde: 1000, hasta: 3000, siguiente: 'Level 3' },
    '3': { lifetime: 4913, saldo: 247,  etiqueta: 'Level 3', ventaja: '12% off',  desde: 3000, hasta: 5000, siguiente: 'Level 4' },
    '4': { lifetime: 5240, saldo: 980,  etiqueta: 'Level 4', ventaja: '15% off',  desde: 5000, hasta: 5000, siguiente: '' }
  };
  var d = NIVELES[n] || NIVELES['0'];

  var panel = document.querySelector('[data-members-panel]');
  var entrar = document.querySelector('[data-members-entrar]');
  if (!panel) { arranca(); return; }
  panel.classList.remove('members--oculto');
  if (entrar) entrar.classList.add('members--oculto');

  pon('[data-members-nombre]', 'Marta Ferrer');
  pon('[data-members-hasta]', mil(d.hasta));
  pon('[data-members-saldo]', mil(d.saldo));
  pon('[data-members-ventaja]', d.ventaja);
  pon('[data-members-siguiente]', d.siguiente);

  var nivelEl = document.querySelector('[data-members-nivel]');
  if (nivelEl && nivelEl.childNodes[0]) nivelEl.childNodes[0].nodeValue = d.etiqueta || String(d.lifetime);

  var faltan = Math.max(0, d.hasta - d.lifetime);
  pon('[data-members-faltan]', mil(faltan));
  var pFalta = document.querySelector('[data-members-falta]');
  if (pFalta) pFalta.hidden = !d.siguiente;

  var tramo = d.hasta - d.desde;
  var pct = tramo <= 0 ? 100 : Math.floor(((d.lifetime - d.desde) / tramo) * 100);
  if (faltan > 0) pct = Math.max(0, Math.min(99, pct));
  var barra = document.querySelector('[data-members-barra]');
  if (barra) barra.style.setProperty('--pct', pct + '%');

  var cifra = document.querySelector('[data-members-lifetime]');
  if (cifra) { cifra.setAttribute('data-members-fin', String(d.lifetime)); contar(cifra, d.lifetime); }
})();

// ── LA TARJETA SIGUE AL RATÓN ─────────────────────────────────────────────────────────────────
// El brillo nace donde está el cursor y la tarjeta se inclina un poco hacia él. Es lo que separa
// "material" de "animación": un barrido que cruza siempre igual se nota que está grabado.
//
// ⚠️ NO HACE NADA EN TÁCTIL. En un móvil no hay "pasar por encima": el primer toque dispararía el
// efecto y se quedaría encendido hasta tocar otra cosa, que es peor que no tenerlo.
//
// ⚠️ NI CON EL MOVIMIENTO REDUCIDO ACTIVADO. Quien lo pide en su sistema suele hacerlo porque el
// movimiento le marea, y una tarjeta que se inclina al pasar por encima es exactamente eso.
(function () {
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finoPuntero = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (quieto || !finoPuntero) return;

  var tarjeta = document.querySelector('[data-members-tarjeta]');
  if (!tarjeta) return;

  var pendiente = false, ultimo = null;

  function pintar() {
    pendiente = false;
    if (!ultimo) return;
    var r = tarjeta.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var x = (ultimo.clientX - r.left) / r.width;      // 0 a 1
    var y = (ultimo.clientY - r.top) / r.height;
    tarjeta.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
    tarjeta.style.setProperty('--my', (y * 100).toFixed(1) + '%');
    // Se inclina HACIA el cursor: el borde que se mira se acerca. Al revés parece que huye.
    tarjeta.style.setProperty('--ry', ((x - 0.5) * 8).toFixed(2) + 'deg');
    tarjeta.style.setProperty('--rx', ((0.5 - y) * 5).toFixed(2) + 'deg');
  }

  // El movimiento del ratón dispara muchísimos eventos; se pinta una vez por fotograma y no más.
  tarjeta.addEventListener('pointermove', function (ev) {
    ultimo = ev;
    if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); }
  });

  tarjeta.addEventListener('pointerleave', function () {
    ultimo = null;
    tarjeta.style.setProperty('--rx', '0deg');
    tarjeta.style.setProperty('--ry', '0deg');
    tarjeta.style.setProperty('--mx', '50%');
    tarjeta.style.setProperty('--my', '50%');
  });
})();
